<template>
  <el-dialog
    :title="`策略配置详情 — ${tagName}`"
    :visible.sync="visible"
    width="620px"
    :close-on-click-modal="false"
  >
    <el-table v-loading="loading" :data="strategyRows" border stripe size="small">
      <el-table-column prop="name" label="策略组名称"></el-table-column>
      <el-table-column prop="type" label="策略类型" width="140"></el-table-column>
      <el-table-column label="配置状态" width="120" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.configured ? 'success' : 'info'" size="small">
            {{ scope.row.configured ? '已配置' : '未配置' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="right">
        <template slot-scope="scope">
          <el-button
            :type="scope.row.configured ? 'danger' : 'primary'"
            size="mini"
            @click="toggleConfig(scope.row)"
          >{{ scope.row.configured ? '移除配置' : '添加配置' }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'StrategyDialog',
  props: {
    strategyConfig: { type: Object, default: () => ({}) },
    companyType: { type: String, default: '' }
  },
  data() {
    return {
      visible: false,
      tagName: '',
      tagId: '',
      // 策略组列表：由 /strategy/selectAllGroupsByCompanyIdOfUser 返回，替代原先的静态 STRATEGY_GROUPS
      strategyGroups: [],
      loading: false,
      groupReq: {
        companyId: ''
      }
    };
  },
  computed: {
    strategyRows() {
      const config = this.strategyConfig[this.tagId] || {};
      return this.strategyGroups.map(g => ({
        ...g,
        // 本地操作过的策略组以本地值为准（保证乐观更新与失败回滚生效）；
        // 未操作过的回退到接口返回的 isLabelSet
        configured: Object.prototype.hasOwnProperty.call(config, g.id)
          ? !!config[g.id]
          : g.isLabelSet
      }));
    }
  },
  methods: {
    open(tag) {
      this.tagId = tag.id;
      this.tagName = tag.name;
      this.visible = true;
      this.fetchStrategyGroups(tag);
    },
    // 每次打开弹窗都重新拉取策略组，保证配置状态基于最新数据
    fetchStrategyGroups(tag) {
      this.loading = true;
      this.groupReq.companyId = tag.companyId;
      this.groupReq.labelDetailId = tag.detailId;
      this.$ajax({
        url: '/label/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: this.groupReq
      })
        .then((res) => {
          this.loading = false;
          this.strategyGroups = this.normalizeGroups(res.data);
        })
        .catch(() => {
          // 失败提示已由 $ajax 响应拦截器统一弹出，这里只清空列表避免展示脏数据
          this.loading = false;
          this.strategyGroups = [];
        });
    },
    // 接口字段转成表格所需结构：groupName -> name，businessType -> type（枚举转中文），
    // isLabelSet 必须保留，否则 configured 无法取到接口返回的配置状态
    normalizeGroups(data) {
      const list = Array.isArray(data) ? data : ((data && data.list) || []);
      return list.map(g => ({
        id: g.id,
        name: g.groupName || '',
        type: this.companyType,
        isLabelSet: g.isLabelSet
      }));
    },
    toggleConfig(row) {
      // 目标状态由本行当前显示状态取反。行状态已合并「本地操作结果 + 接口 isLabelSet」，
      // 交给父级直接使用，父级不再自行推断，避免 operationType 判断错误
      this.$emit('toggle-strategy', {
        id: this.tagId,
        groupId: row.id,
        next: !row.configured
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/tagpools/strategy-dialog.vue